var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _line, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196.431,
    height: 85.123,
    viewBox: "0 0 196.431 85.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d,.h,.i{fill:#fff;}.a,.i,.j{stroke:#f27476;}.a{stroke-dasharray:2;}.b{fill:#fd858a;}.c{fill:#fe999a;}.e,.j,.l{fill:none;}.e{stroke:#ec6e72;}.f{fill:#f27476;}.g{fill:#fc9699;}.h{stroke:#f37579;}.i{stroke-width:1.3px;}.j{stroke-width:2px;}.k{stroke:none;}.m{filter:url(#d);}.n{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f86f77",
    result: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f28a8b",
    result: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(131.724 30.451)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 27.336,
    cy: 27.336,
    r: 27.336
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 27.336,
    cy: 27.336,
    r: 26.836
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(164.943 17.994)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 14.879,
    cy: 14.879,
    r: 14.879
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 14.879,
    cy: 14.879,
    r: 14.379
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(2.309 3.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 23.53,
    cy: 23.53,
    r: 23.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 23.53,
    cy: 23.53,
    r: 23.03
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(27.223 19.378)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 21.108,
    cy: 21.454,
    rx: 21.108,
    ry: 21.454
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 21.108,
    cy: 21.454,
    rx: 20.608,
    ry: 20.954
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(49.369 54.673)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 15.225,
    cy: 15.225,
    r: 15.225
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 15.225,
    cy: 15.225,
    r: 14.725
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.292 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 114.23,
    height: 70.175,
    rx: 6,
    transform: "translate(33.027 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 123.587,
    height: 5.458,
    rx: 2.729,
    transform: "translate(27.959 69.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H134.893a0,0,0,0,1,0,0V0a6.628,6.628,0,0,1-6.628,6.628H6.628A6.628,6.628,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(21.721 71.735)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 106.043,
    height: 62.378,
    rx: 6,
    transform: "translate(37.315 3.899)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "matrix(1, 0, 0, 1, -11.29, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 106.043,
    height: 62.378,
    rx: 6,
    transform: "translate(48.61 3.9)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(37.315 3.899)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 106.043,
    height: 62.378,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 0.5,
    y: 0.5,
    width: 105.043,
    height: 61.378,
    rx: 5.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H33.918L32.155,3.509H2.4Z",
    transform: "translate(72.403 71.735)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, -11.29, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H33.918L32.155,3.509H2.4Z",
    transform: "translate(83.7 71.73)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3.025,0H99.078A3.073,3.073,0,0,1,102.1,3.119V24.951a3.073,3.073,0,0,1-3.025,3.119H82.524v10.2L67.211,28.07H3.025A3.073,3.073,0,0,1,0,24.951V3.119A3.073,3.073,0,0,1,3.025,0Z",
    transform: "translate(2.269 21.053)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M3.025,0H99.078A3.073,3.073,0,0,1,102.1,3.119V24.951a3.073,3.073,0,0,1-3.025,3.119H82.524v10.2L67.211,28.07H3.025A3.073,3.073,0,0,1,0,24.951V3.119A3.073,3.073,0,0,1,3.025,0Z",
    transform: "translate(0 18.713)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 41.326,
    height: 3.119,
    rx: 1.559,
    transform: "translate(33.027 39.766)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 28.07,
    height: 3.119,
    rx: 1.559,
    transform: "translate(33.027 29.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 44.055,
    height: 3.119,
    rx: 1.559,
    transform: "translate(33.027 34.308)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 34.698,
    height: 3.119,
    rx: 1.559,
    transform: "translate(63.436 29.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.713,
    height: 3.119,
    rx: 1.559,
    transform: "translate(79.421 34.308)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.686 23.782)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M115.14,229.89h1.051a1.2,1.2,0,0,0,.152.03,8.1,8.1,0,0,1,2.643.614,8.858,8.858,0,0,1,5.506,6.8c.065.33.093.667.138,1v1.051a1.2,1.2,0,0,0-.03.151,8.3,8.3,0,0,1-1.025,3.532,8.8,8.8,0,0,1-7.535,4.743,8.213,8.213,0,0,1-4.565-1.033,8.788,8.788,0,0,1-4.762-7.54,8.31,8.31,0,0,1,1.038-4.582,8.833,8.833,0,0,1,6.351-4.621C114.445,229.966,114.795,229.936,115.14,229.89Z",
    transform: "translate(-106.698 -229.89)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(186.396 62.977)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 4.498,
    cy: 4.844,
    rx: 4.498,
    ry: 4.844
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 4.498,
    cy: 4.844,
    rx: 3.848,
    ry: 4.194
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "j",
    x2: 196.431,
    transform: "translate(0 78.52)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M0,0H14.533a0,0,0,0,1,0,0V10.035A7.267,7.267,0,0,1,7.267,17.3h0A7.267,7.267,0,0,1,0,10.035V0A0,0,0,0,1,0,0Z",
    transform: "translate(177.4 60.901)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M14.706,0V12.08a5.252,5.252,0,0,1-5.252,5.252h-4.2A5.252,5.252,0,0,1,0,12.08s5.361.53,9.037-2.49S14.706,0,14.706,0Z",
    transform: "translate(177.261 60.925)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/Reject.383f56d14960dc39b14988e1c7f3c88d.svg";
export { ForwardRef as ReactComponent };